import { useMutation } from 'react-query';
import { API } from '../../CommonUtils/axiosWithDefaults';

interface CreateBatchResult {
  batchId: string;
}

const createBatch = async (): Promise<CreateBatchResult> => {
  return API.post('/Adviser/PdfImport/CreateBatch');
};

export const usePdfCreateBatchMutation = () => {
  return useMutation(createBatch);
};
